import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { EquipmentInventory } from "../../../features/FloorManager/typings/svg.types";

export function useRemoteFetchEquipmentInventory(options?: { enabled?: boolean }) {
  return useRemoteQuery<EquipmentInventory[]>({
    queryKey: "equipment-inventory",
    url: "/equipment-inventory",
    enabled: options?.enabled
  });
}
